import React, { useEffect, useState } from 'react'
import { Button, Col, Drawer, Input, Row, Typography } from 'antd'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Product } from '@a4b/api/src/modules/Monetisation/Puja/types'
import PujaAddonItem from '../PujaAddonItem'
import styled from 'styled-components'

const { Title } = Typography

const ListAllItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`
interface Props {
    showItemsPanel: boolean
    setShowItemsPannel: (state: boolean) => void
    createItem: () => void
    productList: Product[]
    added: (item: Product) => void
    searchQuery: string
    onSearchChange: (value: string) => void
}

const ProductListDrawer: React.FC<Props> = ({
    showItemsPanel,
    setShowItemsPannel,
    createItem,
    productList,
    added,
    searchQuery,
    onSearchChange
}) => {
    return (
        <Drawer
            width={600}
            visible={showItemsPanel}
            placement='left'
            closable
            onClose={() => setShowItemsPannel(!showItemsPanel)}
        >
            <Col span={24}>
                <Row justify='space-between' style={{ marginBottom: '16px' }}>
                    <Title level={4}>Product Items</Title>
                    <Button type="primary" shape="round" onClick={createItem}>
                        <PlusOutlined /> Add
                    </Button>
                </Row>

                <Input
                    placeholder="Search products by slug"
                    prefix={<SearchOutlined />}
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    style={{ marginBottom: '16px' }}
                    allowClear
                />

                <ListAllItems>
                    {productList?.map((item: Product) => (
                        <PujaAddonItem formItems={item} key={`${item.master_product_id}`} added={added} />
                    ))}
                </ListAllItems>
            </Col>
        </Drawer>
    )
}

export default ProductListDrawer